<script>

/*

This comp controls transition-in and closing transitions from within.

*/


export default {
    props: {
        size: {
            type: String,
            default: 'normal'
        }
    },
    mounted() {        
           this.disableBodyScroll()  
           
        //add animation fade-in-slide to ref sideslidecontainer:
        this.$refs.sideslidecontainer.classList.add('fade-in-container')
        //remove it after 250ms:
        setTimeout(() => {
            this.$refs.sideslidecontainer.classList.remove('fade-in-container')
        }, 250)

        //add animation slide-in class to ref sideslidewrap:
        this.$refs.sideslidewrap.classList.add('slide-in-slide')
        //remove it after 250ms:
        setTimeout(() => {
            this.$refs.sideslidewrap.classList.remove('slide-in-slide')
        }, 250)

    },
    methods: {
        disableBodyScroll() {
            //disable scroll to body and html:
            document.body.style.overflow = 'hidden'
            document.documentElement.style.overflow = 'hidden'
        },
        reenableBodyScroll() {
            //reenable scroll to body and html by setting it back to defaults:
            document.body.style.overflow = 'auto'
            document.documentElement.style.overflow = 'auto'                    
            },        
        closeMe() {
            //add fade out animation to ref sideslidecontainer:
            this.$refs.sideslidecontainer.classList.add('fade-out-container')

            //add slide out animation to ref sideslidewrap:
            this.$refs.sideslidewrap.classList.add('slide-out-slide')

            this.reenableBodyScroll()

            //emit close after 250ms:
            setTimeout(() => {
                this.$emit('close')
            }, 250)
        }
    },
}

</script>


<template>

    <div class="vs-component con-vs-popup holamundo vs-popup-primary" ref="sideslidecontainer">
        
                
        <div :class="`sideslidewrap p-4  w-screen85 ${size === 'large' ? 'md:w-screen85' : 'w-screen40'}`" ref="sideslidewrap">
                <div class="flex justify-end">
                    <i @click="closeMe" class="vs-icon notranslate icon-scale vs-popup--close vs-popup--close--icon material-icons null" style="background: rgb(255, 255, 255);">close</i>
                </div>
                <slot></slot>
                <div class="flex justify-end mt-8">
        <vs-button
          class="w-full"
          @click="closeMe"
          >Ok</vs-button
        >
      </div>
      </div>

      <div class="vs-popup--background" @click="closeMe"></div>

    </div>

</template>


<style lang="scss">

.sideslidewrap {
    background-color: white;
    position: absolute;
    top: 0;
    right: 0;
    height: 100vh;    
    overflow: scroll;
    z-index: 11;
}

.fade-in-container {
    //the container
    animation: fade-in-slide 0.25s ease-in-out;
}

.fade-out-container {
    //the container
    animation: fade-out-slide 0.25s ease-in-out;
}

.slide-in-slide {
    //the actual slide
    animation: slide-in 0.25s ease-in-out;
}

.slide-out-slide {
    //the actual slide
    animation: slide-out 0.25s ease-in-out;
}

@keyframes fade-in-slide {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}

@keyframes fade-out-slide {
    0% {
        opacity: 1;        
    }
    100% {
        opacity: 0;        
    }
}

@keyframes slide-in {
    0% {
        transform: translateX(100%);
    }
    100% {
        transform: translateX(0%);
    }
}

@keyframes slide-out {
    0% {
        transform: translateX(0%);
    }
    100% {
        transform: translateX(100%);
    }
}


</style>